import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { InputProps } from "../../interfaces/props/InputProps";
import { logger } from "../../../../utilities/logger";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

export const Multiline: React.FunctionComponent<InputProps> = ({
  displayName,
  isRequired,
  inputValue,
  updateInputValidationStatus,
  inputValidator
}: InputProps) => {
  const rows = React.useRef<number>(Number.isInteger(+inputValue?.xml?.NumLines) && +inputValue.xml.NumLines > 0 ? inputValue.xml.NumLines : 3);

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "multiLine.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const handleMultiLineFieldOnchange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string): void => {
    updateInputValidationStatus(inputValidator.validate(newValue));
  };

  return (
    <>
      <TextField
        label={displayName}
        disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
        multiline
        rows={rows.current}
        value={inputValue?.value ?? ""}
        onChange={handleMultiLineFieldOnchange}
        required={isRequired()}
        className="xb-sp-input"
      />
    </>
  );
};

export default Multiline;
